import React from 'react'
import NotTopMenu from './NotTopMenu'
import NotBottomMenu from './NotBottomMenu'

const NotAuthCMS = ({ children }) => {
    return (
        <div className=''>
            <div className='not-top-menu px-4 py-3 h10'><NotTopMenu /></div>
            <div className='h80'>{children}</div>
            <div className='not-bottom-menu color3 fw400 f14 h10 d-flex justify-content-center align-items-center'><NotBottomMenu /></div>
        </div>
    )
}

export default NotAuthCMS
